import { cn } from "@/shared/lib/utils"
import { AnimatedNumber } from "@/shared/ui/animated-number"
import { LoadSwap } from "@/shared/ui/load-swap"
import { Skeleton } from "@/shared/ui/skeleton"
import { SlidingPill } from "@/shared/ui/sliding-pill"

export interface Choice {
	id: string
	label: string
	hint?: string
	/** Сколько людей сейчас подходит; undefined: ещё считаем. */
	count: number | undefined
}

/**
 * Группы получателей карточками с числом людей. Выбранную обводит подложка, которая
 * переезжает от карточки к карточке, как в переключателях панели.
 */
export function ChoiceCards({
	choices,
	value,
	onChange,
	label,
}: {
	choices: Choice[]
	value: string | undefined
	onChange: (id: string) => void
	label: string
}) {
	return (
		<div role="radiogroup" aria-label={label} className="relative grid gap-2 sm:grid-cols-2">
			<SlidingPill className="rounded-xl bg-primary/10 shadow-none ring-2 ring-primary" />
			{choices.map((choice) => {
				const active = choice.id === value
				return (
					<button
						key={choice.id}
						type="button"
						role="radio"
						aria-checked={active}
						data-active={active}
						onClick={() => onChange(choice.id)}
						className={cn(
							"relative flex min-h-16 items-start justify-between gap-3 rounded-xl border px-3.5 py-3 text-left transition-colors focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none",
							active
								? "border-transparent"
								: "border-border hover:border-foreground/20 hover:bg-secondary/40",
						)}
					>
						<span className="min-w-0">
							<span className="block text-sm font-medium">{choice.label}</span>
							{choice.hint ? (
								<span className="mt-0.5 block text-xs text-muted-foreground">{choice.hint}</span>
							) : null}
						</span>
						<span className="flex h-5 shrink-0 items-center text-sm tabular-nums text-muted-foreground">
							<LoadSwap loading={choice.count === undefined} autoHeight={false}>
								{choice.count === undefined ? (
									<Skeleton className="h-3.5 w-10 rounded" />
								) : (
									<AnimatedNumber
										value={choice.count}
										className={cn("transition-colors", active && "text-foreground")}
									/>
								)}
							</LoadSwap>
						</span>
					</button>
				)
			})}
		</div>
	)
}
